import FetchApi from "../util/fetchApi";

export default class DataExplorerService {
  constructor() {
    this.fetchApi = new FetchApi();
  }

  cancelRequest() {
    this.fetchApi.cancelRequest();
  }

  async getWorkspaceList(Workspace_id, currentOnly) {
    return (await this.fetchApi.get(`/workspace/${Workspace_id}/dataexplorer/workspacelist?currentOnly=${currentOnly}`))
      .data;
  }

  async getSchemaList(Workspace_id, expandedWorkspaceIds) {
    return (
      await this.fetchApi.post(`/workspace/${Workspace_id}/dataexplorer/schemaList`, {
        expandedWorkspaceIds,
      })
    ).data;
  }

  async getDataSetList(Workspace_id, expandedWorkspaceIds) {
    return (
      await this.fetchApi.post(`/workspace/${Workspace_id}/dataexplorer/dataSetList`, {
        expandedWorkspaceIds,
      })
    ).data;
  }

  async getTableColumns(Workspace_id, schema, tableName) {
    return (
      await this.fetchApi.get(
        `/workspace/${Workspace_id}/dataexplorer/columns/${encodeURIComponent(schema)}/${encodeURIComponent(tableName)}`
      )
    ).data;
  }

  async getQueryResult(Workspace_id, query) {
    return (await this.fetchApi.post(`/workspace/${Workspace_id}/dataexplorer/queryResult`, query)).data;
  }

  async getResultByProcessId(Workspace_id, processId) {
    return (await this.fetchApi.get(`/workspace/${Workspace_id}/dataexplorer/queryResult/${processId}`)).data;
  }

  async stopQueryOnConnection(Workspace_id, connectionId) {
    return (await this.fetchApi.get(`/workspace/${Workspace_id}/dataexplorer/stopQuery/${connectionId}`)).data;
  }

  async getStatistics(Workspace_id, data) {
    return (await this.fetchApi.post(`/workspace/${Workspace_id}/dataexplorer/statistics`, data)).data;
  }

  async getSampleData(Workspace_id, data) {
    return (await this.fetchApi.post(`/workspace/${Workspace_id}/dataexplorer/statistics/sample`, data)).data;
  }

  async getColumnInfo(Workspace_id, data) {
    return (await this.fetchApi.post(`/workspace/${Workspace_id}/dataexplorer/statistics/column`, data)).data;
  }

  async getQueryTabs(Workspace_id) {
    return (await this.fetchApi.get(`/workspace/${Workspace_id}/dataexplorer/query`)).data;
  }

  async getQueryTab(Workspace_id, WorkspaceQuery_id, Type) {
    return (await this.fetchApi.get(`/workspace/${Workspace_id}/dataexplorer/query/${WorkspaceQuery_id}/${Type}`)).data;
  }

  async addQueryTab(Workspace_id, data) {
    return (await this.fetchApi.post(`/workspace/${Workspace_id}/dataexplorer/query`, data)).data;
  }

  async closeQueryTab(Workspace_id, WorkspaceQuery_id) {
    return (await this.fetchApi.get(`/workspace/${Workspace_id}/dataexplorer/query/close/${WorkspaceQuery_id}`)).data;
  }

  async updateQueryTab(Workspace_id, WorkspaceQuery_id, data) {
    return (await this.fetchApi.patch(`/workspace/${Workspace_id}/dataexplorer/query/${WorkspaceQuery_id}`, data)).data;
  }

  async updateQueryVisibility(Workspace_id, WorkspaceQuery_id, data) {
    return (
      await this.fetchApi.patch(`/workspace/${Workspace_id}/dataexplorer/query/${WorkspaceQuery_id}/visibility`, data)
    ).data;
  }

  async deleteQueryTab(Workspace_id, WorkspaceQuery_id) {
    return (await this.fetchApi.delete(`/workspace/${Workspace_id}/dataexplorer/query/${WorkspaceQuery_id}`)).data;
  }

  async startDownload(Workspace_id, data) {
    return (await this.fetchApi.post(`/workspace/${Workspace_id}/dataexplorer/queryResult/startDownload`, data)).data;
  }

  async getDownloadStatus(Workspace_id, ProcessQueue_id) {
    return (await this.fetchApi.get(`/workspace/${Workspace_id}/dataexplorer/queryResult/status/${ProcessQueue_id}`))
      .data;
  }

  async downloadCSV(Workspace_id, data) {
    return (await this.fetchApi.post(`/workspace/${Workspace_id}/dataexplorer/queryResult/download`, data)).data;
  }

  async getComputeClusters(Workspace_id) {
    return (await this.fetchApi.get(`/workspace/${Workspace_id}/dataexplorer/computeClusters`)).data;
  }

  async generateAIQuery(Workspace_id, data) {
    return (await this.fetchApi.post(`/workspace/${Workspace_id}/dataexplorer/query/generate`, data)).data;
  }
}
